import Logger from '@yakit/core/logger'; let log = Logger(false);
import { derived, writable, get, type Writable, type Readable } from 'svelte/store'
import { _get, _set, money, assign} from "@yakit/core/index";
import { dayjs, findIndexById, findById } from "@yakit/core/utils";
import { getCustId } from '~/user';
import growl from '@yakit/ui/growl';
import { f7 } from 'framework7-svelte';
import dataApiFactory from '~/api/dataApiFactory';
/**
 * Customer Dash info endpoints
 */
export function createTranAdjustController({ tranModel, tranAdjustQuery }){
  log("tranAdjustController: factory called", { tranModel, tranAdjustQuery })
  const getTranModel = () => tranModel
  const getTranAdjustQuery = () => tranAdjustQuery
  const adjustApi = dataApiFactory.ar.adjust
  let tranData = writable(null)

  /** checkout will set this to true after the payTranStore has been finalized and is ready to confirm*/
  const showConfirmation = writable(false)
  const showThanks = writable(false)
  const reciept = writable({})

  async function init() {
    const tran = await tranAdjustQuery.init()
    tranData.set(tran)
    log("tranAdjustController: init tran", tran)
    if(tran) {
      tranModel.set(tran)
      log("tranAdjustController: after set, get()", tranModel.get())
    } else {
      log("tranAdjustController: tran is null/undefined")
    }
  }
  init().catch(err => {
    log("tranAdjustController: init error", err)
  })

  function findLineByTranId(id){
    const ptmodel = tranModel
    let payLine = findById(ptmodel.cartContents, id, 'arTran.id')
    return payLine ? payLine : null
  }

  function findApplyAmountById(id, _){
    let item = findLineByTranId(id)
    // log("findLineByTranId", id, item)
    return item ? _get(item, 'applyAmount') : null
  }

  function addOrUpdateLine(id, amt) {
    if(!id) throw "addOrUpdateLine called without id"
    //let currency get value
    let applyAmount = money(amt).value
    // log("addOrUpdateLine id|applyAmount", id, applyAmount)
    const ptmodel = tranModel
    ptmodel.cartContents.update((data) => {
      let newData = data
      // log("existing data", data)
      let item = findById(data, id, 'arTran.id')
      //if amount is null then its a delete
      let isDelete = applyAmount == 0
      if(item){
        if(isDelete){
          const idx = findIndexById({ list: data, id, idProp: 'arTran.id' })
          data.splice(idx, 1)
        } else {
          _set(item, 'applyAmount', applyAmount)
        }
        log("changing item", item)
      } else if(!isDelete){
        let newItem = {
          arTran: {id}, applyAmount: applyAmount
        }
        log("item new", newItem)
        newData = [...data, newItem]
      }
      log("newData", newData)
      return newData;
    });
  }


  function paySelected(lines) {
    tranModel.cartContents.set(lines)
  }
  function resetData(){
    tranModel.clear()
    tranModel.cartContents.set([])
    tranData.set(null)
  }

  async function submit(){

    f7.dialog.confirm('This will run Adjust. Are you sure?', 'Run Adjust', async () => {
      try {
        const tranId = tranModel.get()?.id
        let lines = get(tranModel.cartContents) as any[]
        if (lines.length === 0){
          growl.warn('Select at least one tran')
          return
        }
        const res = await adjustApi.create({
          arTran: { id:  tranModel.get().id },
          lines: lines.map(line => ({
            amount: line.applyAmount,
            arTran: { id: line.arTran.id }
          }))
        })
        resetData()
        // Navigate to the transaction show page after successful creation
        // Replace the adjust route in history instead of adding a new entry
        if(tranId) {
          const targetUrl = `/ar/trans/${tranId}`
          const router = f7.views.main.router
          // Navigate to transaction page
          router.navigate(targetUrl)
        }
      } catch (error) {
        console.error('Error running adjust:', error)
      }
    })
    
  }

  return {
    init,
    tranModel,
    tranAdjustQuery,
    getTranModel,
    getTranAdjustQuery,
    tranData,
    showConfirmation,
    submit,
    findApplyAmountById,
    addOrUpdateLine,
    // payAll,
    // payPastDue,
    paySelected,
    showThanks,
    reciept
  }
}
